import { servicesApi } from '@/services/api/deprecated';
import { getCrossAppCacheAsync, setCrossAppCache } from '@/utils/cross-app-cache';

export const getRoleDefinitions = async (accountId: number) => {
  const url = `/accounts/${accountId}/role_definitions`;
  const cachedRoleDefinitions = await getCrossAppCacheAsync(url);
  if (cachedRoleDefinitions != null) {
    return cachedRoleDefinitions;
  }
  const request = servicesApi.get(url);
  // Cache the request itself, so if we catch it halfway through, we can await for it instead of making a new request.
  setCrossAppCache({ key: url, value: request, ttl: 10000, isAsync: true });
  try {
    const { data } = await request;
    // Once it's complete, we can replace the request with the data.
    setCrossAppCache({ key: url, value: data, ttl: 10000 });
    return data;
  } catch (error) {
    // If the request fails, we remove the request from the cache so we can try again.
    setCrossAppCache({ key: url, value: null });
    return null;
  }
};
